module.exports = __webpack_public_path__ + "img/greyclayhairsm.66e0a59e.webp";